import React from 'react';
import ZarinPalImg from 'Assets/images/zarinPal_logo.png';
import SamanKishImg from 'Assets/images/SamanKishLogo.jpg';
import { LinearProgress, Stack } from '@mui/material';
import { selectedPortal } from '../../shared/selected.portal';
import { useAtom } from 'jotai';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import useCheckActivatedPaymentGateways from 'Global/Hooks/useCheckActivatedPaymentGateways/useCheckActivatedPaymentGateways';

const PaymentPortals = (props) => {
  const [portal, setPortal] = useAtom(selectedPortal);

  const label = props.label;
  const ZpLabel = props.ZpLabel;
  const SmLabel = props.SmLabel;

  const gateways = useCheckActivatedPaymentGateways();

  const isGateWayLoading = gateways === 'loading';

  const isSamanKishEnabled =
    typeof gateways !== 'string' &&
    gateways &&
    gateways?.findIndex((item) => item.Id === 2) !== -1;

  const isZarinPalEnabled =
    typeof gateways !== 'string' &&
    gateways &&
    gateways?.findIndex((item) => item.Id === 1) !== -1;

  return (
    <React.Fragment>
      <p style={{ marginBottom: '.5em' }}>{label}</p>

      <Stack gap=".5em" direction="row-reverse">
        {isGateWayLoading ? (
          <LinearProgress
            sx={{
              width: '100%',
            }}
            color="colorPrimer"
          />
        ) : (
          <React.Fragment>
            {isZarinPalEnabled ? (
              <div
                onClick={() => {
                  setPortal('zp');
                }}
              >
                <Stack
                  alignItems="center"
                  border="1px solid gray"
                  width="102px"
                  p=".5em"
                  borderRadius={'10px'}
                  sx={{
                    cursor: 'pointer',
                    '&&': {
                      backgroundColor:
                        portal === 'zp'
                          ? `${themeColors.ColorPrimary} !important`
                          : `${themeColors.ColorSecondary} !important`,
                    },
                    transition: 'all .5s ease',
                  }}
                >
                  <img
                    src={ZarinPalImg}
                    alt={'Zarin Pal'}
                    width={30}
                    height={30}
                  />
                  <p
                    style={{
                      color:
                        portal === 'zp'
                          ? themeColors.ColorSecondary
                          : themeColors.ColorPrimary,
                    }}
                  >
                    {ZpLabel}
                  </p>
                </Stack>
              </div>
            ) : (
              <></>
            )}

            {isSamanKishEnabled ? (
              <div
                onClick={() => {
                  setPortal('sm');
                }}
              >
                <Stack
                  alignItems="center"
                  border="1px solid gray"
                  width="auto"
                  p=".5em"
                  borderRadius={'10px'}
                  sx={{
                    cursor: 'pointer',
                    '&&': {
                      backgroundColor:
                        portal === 'sm'
                          ? `${themeColors.ColorPrimary} !important`
                          : `${themeColors.ColorSecondary} !important`,
                    },
                    transition: 'all .5s ease',
                  }}
                >
                  <img
                    src={SamanKishImg}
                    alt={'Zarin Pal'}
                    width={30}
                    height={30}
                  />
                  <p
                    style={{
                      color:
                        portal === 'sm'
                          ? themeColors.ColorSecondary
                          : themeColors.ColorPrimary,
                    }}
                  >
                    {SmLabel}
                  </p>
                </Stack>
              </div>
            ) : (
              <></>
            )}
          </React.Fragment>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default PaymentPortals;
